import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import {Button} from "@mui/material";
import React from "react";
import LoadingButton from "@mui/lab/LoadingButton";

const ConfirmDialog = ({message, confirmBtnText, onConfirm, onClose, isOpen, zIndex = 1000, loading}) => {
  return (
    <Dialog
      sx={{
        zIndex: zIndex,
      }}
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{message}</DialogTitle>
      {/* <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Delete Item?
        </DialogContentText>
      </DialogContent> */}
      <DialogActions>
        <LoadingButton
          onClick={onClose}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          loading={loading}
          onClick={onConfirm}
          autoFocus
        >
          {confirmBtnText}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog
